import React, { useState } from 'react';
import { Button, FormControl, Dialog, DialogContent, DialogActions, IconButton, Popover, Grid } from '@mui/material';
import requests from 'api/requests';
import { useSnackbar } from 'notistack';
import { IATPRequest } from '../types';
import { FORM } from '../config';
import { FIELDS } from '../fields';
import { DeleteOutlined } from '@mui/icons-material';
import InstanceModalInfo from './info';

interface InstanceModalProps {
  instance: IATPRequest;
  onClose?: ()=>void;
  onSave?: (instance:IATPRequest)=>void;
  onDelete?: (instance:IATPRequest)=>void;
}

export default function InstanceModal(props:InstanceModalProps) {
  const { enqueueSnackbar } = useSnackbar();
  const [instance, setInstance] = useState({...props.instance});
  const [ deleteConfirmEl, setDeleteConfirmEl] = React.useState<HTMLButtonElement | null>(null);

  const {
    onSave,
    onDelete,
    onClose
  } = props;

  const handleChange = (name:keyof IATPRequest) => (event:any) => {
    handleChangeValue(name)(event.target.value);
  };

  const handleChangeValue = (name:keyof IATPRequest) => (value:any) => {
    instance[name] = value as never;
    setInstance({...instance});
  }

  const remove = () => {
    requests.delete(`/admin/atp/request/${instance.id}/`).then((r) => {
      enqueueSnackbar("Видалено", {variant: 'success'});
      if(onDelete){
        onDelete(instance);
      }
    })
  }

  const update = () => {
    let _data:IATPRequest = {
      full_name: instance.full_name,
      phone: instance.phone,
    };
    FORM.fields.map((field_name) => {
      _data[field_name] = instance[field_name] as never;
      return field_name;
    });
    
    let url = `/admin/atp/request/`;
    var method = requests.post;
    if(instance.id){
      url = `/admin/atp/request/${instance.id}/`;
      method = requests.patch;
    }else{
      _data.source = window.location.hostname;
    }

    method(url, _data).then((r) => {
      enqueueSnackbar("Збережено", {variant: 'success'});
      if(onSave){
        onSave(r.body);
      }
    });
    
  }

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth="sm"
      onClose={onClose}
    >
      <form
        onSubmit={(e:any) => {
          e.preventDefault();
          update();
        }}
      >
        <DialogContent>

        <Grid container spacing={3}>
          {FORM.fields.map((field_name) => {
            const field = FIELDS[field_name].field(instance[field_name], handleChange(field_name));
            if(!field) return null
            return (
              <Grid key={field_name} item xs={12} md={6}>
                <FormControl fullWidth key={field_name}>
                  {field}
                </FormControl>
              </Grid>
            )
          })}
        </Grid>

        {instance.id ? (
          <React.Fragment>
            <InstanceModalInfo
              instance={instance}
            />
          </React.Fragment>
        ):null}
          
        </DialogContent>
        <DialogActions>
          {instance.id ? (
            <IconButton
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                setDeleteConfirmEl(event.currentTarget);
              }}
              color="secondary"
              style={{marginRight: 'auto'}}
            >
              <DeleteOutlined />
            </IconButton>
          ):null}
          <Button
            onClick={onClose}
          >
            Відмінити
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
          >
            Зберегти
          </Button>
        </DialogActions>
      </form>
      
      <Popover
        open={!!deleteConfirmEl}
        anchorEl={deleteConfirmEl}
        onClose={()=>setDeleteConfirmEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Button
          color="primary"
          onClick={()=>{
            remove();
            setDeleteConfirmEl(null);
          }}
        >Підтвердити</Button>
      </Popover>
    </Dialog>
  );
}